const initMediaGallery = () => {
	const mediaGallery = document.querySelector('.act-media-kit-photo-gallery');
	if ( !mediaGallery ) return;
	const mediaGalleryFilter = mediaGallery.querySelector('#media-kit-photo-gallery-category-filter');
	if ( !mediaGalleryFilter ) return;
	mediaGalleryFilter.addEventListener('change', function(e) {
		e.preventDefault();
		const selected = [];
		mediaGalleryFilter.querySelectorAll('input[name=media-kit-photo-gallery-category]:checked')
			.forEach((select) => {
				selected.push(select.value);
			});
		const mediaElements = mediaGallery.querySelectorAll('.media');
		if ( selected.length ) {
			mediaGallery.classList.add('filtered');
			mediaElements.forEach((el) => {
				const elVisible = el.classList.contains('active');
				const hasAnyType = selected.some((className) => {
				  return el.classList.contains(className);
				});
				if ( hasAnyType && !elVisible ) {
					el.classList.add('active');
				} else if ( !hasAnyType && elVisible ) {
					el.classList.remove('active');
				}
			});
		} else {
			mediaGallery.classList.remove('filtered');
			mediaGallery.querySelectorAll('.media.active')
				.forEach((el) => {
					el.classList.remove('active');
				});
		}
	});
}

document.addEventListener("DOMContentLoaded", initMediaGallery);